export enum HttpParams {
  AccessToken = '758d0b20-2d23-4cd0-ac2a-3e59a3941e67',
  BannerId = '07e094ff-d4cf-4460-b998-8fe9e3fd1ec6',
  Bucket = 'bc3ff09d-343e-4d03-b672-8353896360bc',
  CartId = 'bbfb06a1-467c-4505-9766-9113a1dd9b3d',
  Id = '4097c8f8-86ba-4d0a-8d8f-82ed9b5d49b6',
  ItemId = 'd7236e53-54cc-4620-b722-42a876072477',
  OrderId = '024f8fe0-8079-4b9b-a728-a6eb5e90ff80',
  ShipmentId = '436e0b0a-ca43-42a2-b81c-aa28b0d15b44',
  Number = '5ec5c779-0325-44de-b99a-aa4f87d44700',
  SKU = 'db730f9c-8e99-407d-be1a-e19fff908e53',
  Slug = 'f8b7c6ae-81bb-4698-938a-7900032288d0',
  Variant = '0e4e06d4-7993-4c36-adf4-60718a7ff9e3',
}
